import { downloadS3File } from "services";

import { handleImageUpload, saveFile } from "utils";

import { adminRoles } from "enums";

import { Message as message } from "components";

export const checkAdminAccess = (role, route, showError = false) => {
  if (role && !route.includes("dashboard")) {
    const userRole = adminRoles.find((v) => v.role === role);
    const dissallowedPages = userRole.dissallowAccess;

    if (dissallowedPages.includes(route.replace(/\/$/, ""))) {
      if (showError) {
        message({
          content: "The gremlins haven't given you access to that area.",
          icon: "gremlin",
        });
      }

      return false;
    }
  }

  return true;
};

export const incomplete = () =>
  message({
    content: "The gremlins demand that everything required is sent to them.",
    icon: "gremlin",
  });

export const fileUpload = (file, location, setImageSuccess, setImageURL, setLoading) => {
  setImageSuccess(false);
  setImageURL(false);

  handleImageUpload({ file, location })
    .then((res) => {
      if (res === "invalid type" || res === "invalid size") {
        return message({
          content: res === "invalid type" ? "Gremlins only eat jpg or png files." : "Your file was too large for the gremlins.",
          icon: "gremlin",
        });
      }
      setImageSuccess(true);
      setImageURL(res.location);
      message({
        content: "Your file was accepted by the gremlins.",
        icon: "gremlin",
      });
    })
    .finally(() => {
      setLoading(false);
    });
};

export const handleEditorChange = (v, f) => {
  const answer = v.replace(/height="\d*"/g, 'height="auto" style="max-width: 100%;"');

  f(answer);
};

export const getGremlin = () => {
  const gremlins = [
    "https://media.giphy.com/media/V4iVlA2tScmjK/giphy.gif",
    "https://media.giphy.com/media/l1AvALOphoaWbxeRa/giphy.gif",
    "https://media.giphy.com/media/sYPglPcsgBiww/giphy.gif",
    "https://media.giphy.com/media/3o6wryDi8VtkJje5OM/giphy.gif",
    "https://media.giphy.com/media/7MKChN96hWxlC/giphy.gif",
    "https://media.giphy.com/media/en8nykKVUwxLW/giphy.gif",
  ];
  return gremlins[Math.floor(Math.random() * gremlins.length)];
};

export const handleS3Download = async (location) => {
  const data = await downloadS3File(location);
  saveFile(data, new URL(location).pathname.split("/").slice(-1)[0]);
};
